<template>
  <div>
    <v-layout row class="ml-4 mt-4">
      <div :class="ui.textHeadline"> besea </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card :class="ui.cardColorLight">
          <v-img
          class="white--text"
          height="200px"
          :src="require('@/app/assets/images/plant02.jpg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textHeadline"> company access </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div :class="ui.textImage"> Diavik Mine, Copyright © 2018 Rio Tinto. </div>
         </v-layout>
         <v-card-title primary-title>
           <div :class="ui.textTitleError">
             <div class="ml-3">
               Company Access is Restricted
             </div>
            </div>
           <div :class="ui.textDescription">
             <div class="ml-3 mt-2">
               Company access is restricted for current user access credentials. Please contact Company Admin if higher access level is required.
             </div>
           </div>
        </v-card-title>
        <v-layout row>
          <v-spacer/>
          <v-btn flat :color="ui.btnColor" :to="'/userdash'">
            <v-icon left> person </v-icon>
            User Dashboard
           </v-btn>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
    <AppNavigationBottom/>
  </div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  components: {
    AppNavigationBottom
  },
  mixins: [apptheme],
  data: () => ({})
};
</script>
